import axios, { AxiosInstance } from 'axios'
import { Client } from '../client'
import { SC } from '../SC'
import { APIClient } from './APIClient'
import { Auth } from './Auth'
import { Base } from './Base'
import { Docs } from './docs'
import { CustomAxiosConfig } from './types'

export class Skuit {
  clientClient: APIClient
  scClient: APIClient
  auth: Auth
  base: Base
  client: Client
  sc: SC
  docs: Docs

  constructor() {
    this.auth = new Auth()
    this.docs = new Docs(
      new APIClient(
        this.createAxiosInstance(process.env.REACT_APP_API_URL ?? ''),
        this.auth.refreshAccessToken
      )
    )
    this.base = new Base(
      new APIClient(
        this.createAxiosInstance(process.env.REACT_APP_API_URL ?? ''),
        this.auth.refreshAccessToken
      )
    )
    this.clientClient = new APIClient(
      this.createAxiosInstance(process.env.REACT_APP_IC_API_URL ?? ''),
      this.auth.refreshAccessToken
    )
    this.scClient = new APIClient(
      this.createAxiosInstance(process.env.REACT_APP_ISC_API_URL ?? ''),
      this.auth.refreshAccessToken
    )

    this.client = new Client(this.clientClient)
    this.sc = new SC(this.scClient)
  }

  createAxiosInstance(baseURL: string): AxiosInstance {
    const newAxiosInstance = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    newAxiosInstance.interceptors.request.use(
      async (config: CustomAxiosConfig) => {
        config.headers.authorization = `Bearer ${this.auth.getAccessToken()}`

        const facilityFilter = localStorage.getItem('global-facility-filter')
        if (facilityFilter) {
          config.params = config.params || {}
          config.params.facilities = facilityFilter
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    return newAxiosInstance
  }
}

export const skuit = new Skuit()
